import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { notification } from "antd";
import BackIcon from "../../../images/icon-back.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const EmailTemplate = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const isAuthenticated = useSelector((state) => state.user);
  const [content, setContent] = useState("");
  const [id, setId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    host: "",
    port: "",
    user: "",
    password: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);

      const response = await fetch(
        `${url}/api/communication/ge/email/template?site_id=${isAuthenticated?.site_id}`,
        {
          method: "GET",
          headers: headers,
          mode: "cors",
        }
      );

      const json = await response.json();
      setIsLoading(false);

      if (json?.success) {
        setContent(json?.data?.content || "");
        setId(json?.data?._id); // If you get ID in response
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Failed to fetch template:", error);
    }
  };

  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const formSubmit = async (e) => {
    e.preventDefault();

    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);

      const response = await fetch(
        `${url}/api/communication/update/email/template/${id}`,
        {
          method: "PUT",
          headers: headers,
          mode: "cors",
          body: JSON.stringify({ content, site_id: isAuthenticated?.site_id }),
        }
      );

      const json = await response.json();
      setIsLoading(false);

      if (json.success) {
        notification.success({
          message: "Success",
          description: "Updated Successfully",
          duration: 3,
        });
      } else {
        notification.error({
          message: "Failed",
          description: json?.error || "Something went wrong",
          duration: 3,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error submitting form:", error);
    }
  };

  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/communications/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="Back" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>Pickup message</h3>
                  <p>Update the text that goes in the pickup email for your site.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end" />
          </div>
        </div>

        <div className="form-box card-box">
          <div className="row">
            <div className="col-lg-12 mb-4">
              <label className="form-label">Email Template Content</label>
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                  marginBottom: "20px",
                }}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={content}
                  onReady={(editor) => {
                    editor.ui.view.editable.element.style.minHeight = "300px"; // Set your desired height
                    console.log("Editor is ready to use!", editor);
                  }}
                  onChange={(event, editor) => {
                    setContent(editor.getData());
                  }}
                />
              </div>
            </div>

            <div className="col-lg-12 text-end">
              <div className="form-btn-wrap mb-5 pb-5">
                <button
                  type="submit"
                  disabled={isLoading}
                  onClick={formSubmit}
                  className="btn btn-prim w-auto ms-5"
                >
                  {isLoading ? "Saving..." : "Save Template"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate;
